import { HttpService, ApiResponse, TokenInfo } from './http';
import { TaskDetail } from './task';


export const UserProviderMap = {
  github: 0,
  google: 1,
} as const;

export type PointInfo = {
  free: number;
  paid: number;
  next_update: number;
}


export interface UserInfo {
  id: string;
  name: string;
  avatar: string;
  email: string;
  points: PointInfo;
  created_at: string | null;
  last_login_time: string | null;
}




export interface GetLoginUrlRequest {
  provider: number;
}

export interface GetLoginUrlResponse {
  url: string;
  state: string;
}

export interface LoginCallbackRequest {
  code: string;
  state: string;
}

export interface LoginCallbackResponse {
	detail: UserInfo;
	token: TokenInfo;
}


export interface RefreshRequest {
  refresh_token: string;
}

export interface RefreshResponse {
	access_token: string;
	refresh_token: string;
	access_expires_at: string;
	refresh_expires_at: string;
}

export interface LogoutResponse {
	message: string;
}

export interface UserInfoResponse {
	detail: UserInfo;
}

export class AuthApi {
  private static http = new HttpService();
  
  public static async getLoginUrl(params: GetLoginUrlRequest): Promise<ApiResponse<GetLoginUrlResponse>> {
    return this.http.get('/auth/login', params);
  }
  
  public static async handleCallback(params: LoginCallbackRequest): Promise<ApiResponse<LoginCallbackResponse>> {
    return this.http.get('/auth/callback', params);
  }
  
  public static async getUserInfo(): Promise<ApiResponse<UserInfoResponse>> {
    return this.http.get('/auth/info');
  }
  
  public static async logout(): Promise<ApiResponse<LogoutResponse>> {
    return this.http.post('/auth/logout');
  }

}